import { Model } from 'pinia-orm';
import Job from './Job';
import styles from '../../../../../styles.config';
import tinycolor from 'tinycolor2';
import Application from './Application';

export default class Stage extends Model {

    static get entity() {
        return 'stages';
    }

    get color() {
        if (!this.order) {
            return styles.colors.semantic.warning.DEFAULT;
        }

        if (this.onboarding) {
            //When the stage uses onboarding the default color is green
            return styles.colors.gradient['6'];
        } else {
            // iterate between styles.colors.gradient['1'] and styles.colors.gradient['5'], order can be more than 5 though, so we need to calculate the percentage
            let colorIndex = Math.floor((this.order - 1) / (this.sibling_count - 1) * 5) + 1;

            return styles.colors.gradient[colorIndex];
        }
    }

    static fields() {
        return {
            id: this.uid(),
            job_id: this.attr(null),
            order: this.attr(null),
            onboarding: this.boolean(false),
            name: this.attr(''),
            applications_count: this.number(0),
            rejected_count: this.number(0),
            sibling_count: this.number(0),
            anonymised_count: this.number(0),
            job: this.belongsTo(Job, 'job_id'),
            applications: this.hasMany(Application, 'stage_id'),
        };
    }
}
